import React, { useState, useEffect } from 'react';
import { isAuthenticatedSync } from '../services/auth';
import AuthModal from './AuthModal';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = useAuth();
  const [isAuth, setIsAuth] = useState<boolean>(isAuthenticatedSync());
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(true);
  const navigate = useNavigate();
  
  // Проверяем авторизацию при монтировании компонента
  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const authenticated = await auth.checkAuth();
        setIsAuth(authenticated);
        setShowModal(!authenticated);
      } catch (error) {
        console.error('Ошибка при проверке авторизации:', error);
        setIsAuth(false);
        setShowModal(true);
      } finally {
        setLoading(false);
      }
    };
    
    checkAuthentication();
  }, [auth.user]);
  
  // Показываем индикатор загрузки, пока проверяем авторизацию
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Проверка авторизации...</p>
      </div>
    );
  }
  
  // Если пользователь авторизован, показываем защищенный контент
  if (isAuth || auth.user) {
    return <>{children}</>;
  }

  // Если пользователь не авторизован, показываем модальное окно авторизации
  return (
    <>
      <AuthModal 
        open={showModal} 
        onClose={() => navigate('/login')}
        onSuccess={() => setIsAuth(true)}
      />
      {!showModal && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <h2>Для доступа к этой странице необходима авторизация</h2>
          <button 
            onClick={() => setShowModal(true)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Войти
          </button>
        </div>
      )}
    </>
  );
};

export default ProtectedRoute; 